import { Injectable } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IDefaultOfficeHours } from '../interfaces/default-office-hours';
import { IDefaultOfficeHoursForm } from '../interfaces/default-office-hours-form';

@Injectable({ providedIn: 'root' })
export class OfficeHoursService {
  public fixTimeForSave = (a) =>
    a == null ? null : typeof a == 'string' ? a : a.toTimeString().substring(0, 8);

  public fixHoursFormatForSave(o: IDefaultOfficeHours): IDefaultOfficeHours {
    return {
      weekOfficeOpeningTime: this.fixTimeForSave(o.weekOfficeOpeningTime),
      weekOfficeClosingTime: this.fixTimeForSave(o.weekOfficeClosingTime),
      saturdayOpeningTime: this.fixTimeForSave(o.saturdayOpeningTime),
      saturdayClosingTime: this.fixTimeForSave(o.saturdayClosingTime),
      sundayOpeningTime: this.fixTimeForSave(o.sundayOpeningTime),
      sundayClosingTime: this.fixTimeForSave(o.sundayClosingTime),
      openWeekdays: o.openWeekdays,
      openOnSaturday: o.openOnSaturday,
      openOnSunday: o.openOnSunday,
    };
  }

  public setOfficeHoursForm(o: IDefaultOfficeHours): IDefaultOfficeHoursForm {
    //presumably set these values as default times (unless they are overriden by client) cause these values are used in some service clients
    if (o == null)
      o = {
        weekOfficeOpeningTime: '09:00',
        weekOfficeClosingTime: '17:00',
        saturdayOpeningTime: '09:00',
        saturdayClosingTime: '17:00',
        sundayOpeningTime: '09:00',
        sundayClosingTime: '17:00',
        weekendOfficeClosingTime: '09:00',
        weekendOfficeOpeningTime: '17:00',
        openWeekdays: true,
        openOnSaturday: false,
        openOnSunday: false,
      };

    let dateMinutes = (a) => a.getHours() * 60 + a.getMinutes();

    let getTimeControl = function (
      value,
      compareTimeControlName,
      compareTimeDisplayName,
      isOpentime: boolean,
    ): UntypedFormControl {
      let res: UntypedFormControl;

      res = new UntypedFormControl(
        new Date('1970-01-01T' + value),
        (validator: UntypedFormControl) => {
          if (!validator.value) {
            return { valid: false, error: 'Is required' };
          }

          if (!validator.parent) return null;

          var comparerControl = validator.parent.controls[compareTimeControlName];

          if (
            comparerControl.value &&
            ((isOpentime && dateMinutes(validator.value) >= dateMinutes(comparerControl.value)) ||
              (!isOpentime && dateMinutes(validator.value) <= dateMinutes(comparerControl.value)))
          ) {
            validator.markAsDirty();
            return {
              valid: false,
              error:
                'This value must be ' +
                (isOpentime ? 'less' : 'greater') +
                ' than ' +
                compareTimeDisplayName,
            };
          }

          if (!comparerControl.valid && comparerControl.value) {
            comparerControl.setValue(comparerControl.value);
          }

          return null;
        },
      );

      return res;
    };

    return {
      weekOfficeOpeningTime: getTimeControl(
        o.weekOfficeOpeningTime,
        'weekOfficeClosingTime',
        'Week Office Closing Time',
        true,
      ),
      weekOfficeClosingTime: getTimeControl(
        o.weekOfficeClosingTime,
        'weekOfficeOpeningTime',
        'Week Office Opening Time',
        false,
      ),
      saturdayOpeningTime: getTimeControl(
        o.saturdayOpeningTime,
        'saturdayClosingTime',
        'Saturday Closing Time',
        true,
      ),
      saturdayClosingTime: getTimeControl(
        o.saturdayClosingTime,
        'saturdayOpeningTime',
        'Saturday Opening Time',
        false,
      ),
      sundayOpeningTime: getTimeControl(
        o.sundayOpeningTime,
        'sundayClosingTime',
        'Sunday Closing Time',
        true,
      ),
      sundayClosingTime: getTimeControl(
        o.sundayClosingTime,
        'sundayOpeningTime',
        'Sunday Opening Time',
        false,
      ),
      weekendOfficeOpeningTime: new UntypedFormControl(), // getTimeControl(o.weekendOfficeOpeningTime, "weekendOfficeClosingTime", "Weekend Office Closing Time", true),
      weekendOfficeClosingTime: new UntypedFormControl(), //getTimeControl(o.weekendOfficeClosingTime, "weekendOfficeOpeningTime", "Weekend Office Opening Time", false),
      openWeekdays: new UntypedFormControl(o.openWeekdays, Validators.required),
      openOnSaturday: new UntypedFormControl(o.openOnSaturday, Validators.required),
      openOnSunday: new UntypedFormControl(o.openOnSunday, Validators.required),
    };
  }

  public inputErrorToShow(c: any): string {
    return !c.valid && c.dirty && c._errors && c._errors.error ? c._errors.error : null;
  }
}
